import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import { CreateProcedure, PostNewProcedure } from './entity';

export const procedureApi = {
  getByVisit: (visitId: string) => `/api/procedures/visit/${encodeURIComponent(visitId)}`,
  getById: (procedureId: string) => `/api/procedures/${encodeURIComponent(procedureId)}`,
};

export const getProcedures = async (visitId: string): Promise<CreateProcedure[]> => {
  const response = await axiosInstance.get(procedureApi.getByVisit(visitId));
  return response.data;
};
export const postNewProcedure = async (
  visitId: string,
  data: PostNewProcedure,
): Promise<CreateProcedure> =>
  apiCall(
    async () => await axiosInstance.post(procedureApi.getByVisit(visitId), data),
    'api.procedure.createError',
  );

export const deleteProcedure = async (procedureId: string): Promise<string> =>
  apiCall(
    async () => await axiosInstance.delete(procedureApi.getById(procedureId)),
    'api.procedure.deleteError',
  );
